import { render, staticRenderFns } from "./IndicationTemp.vue?vue&type=template&id=883a056a&scoped=true"
import script from "./IndicationTemp.vue?vue&type=script&lang=js"
export * from "./IndicationTemp.vue?vue&type=script&lang=js"
import style0 from "./IndicationTemp.vue?vue&type=style&index=0&id=883a056a&prod&scoped=true&lang=scss"
import style1 from "./IndicationTemp.vue?vue&type=style&index=1&id=883a056a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a056a",
  null
  
)

export default component.exports